import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/version/index.js
// module id = 1013
// module chunks = 0